import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import InfiniteList from "@researchgate/react-intersection-list";
import { useNavigationList } from "@sprout/list-navigation";
import TopicPageViewsTabsInfiniteListItem from "./TopicPageViewsTabsInfiniteListItem";
const TopicPageViewsTabsInfiniteList = (props)=>{
    const { listId , items , loadMore , loading , hasNextPage , navigationListOptions ,  } = props;
    const renderItem = useCallback((index)=>{
        const item = items[index];
        return /*#__PURE__*/ _jsx(TopicPageViewsTabsInfiniteListItem, {
            index: index,
            item: item
        }, item.id);
    }, [
        items
    ]);
    const { navProps , Provider  } = useNavigationList(listId, navigationListOptions);
    const itemsRenderer = useCallback((itemsToRender, ref)=>{
        return /*#__PURE__*/ _jsx("div", {
            ref: (element)=>{
                if (element) {
                    navProps.ref.current = element;
                    ref(element);
                }
            },
            children: itemsToRender
        });
    }, [
        navProps.ref
    ]);
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(InfiniteList, {
            awaitMore: loading ? false : hasNextPage,
            itemsRenderer: itemsRenderer,
            renderItem: renderItem,
            itemCount: items.length,
            onIntersection: loadMore,
            pageSize: items.length,
            threshold: "25%"
        })
    });
};
export default TopicPageViewsTabsInfiniteList;
